export const UPDATE_REQUEST_STATUS = 'UPDATE_REQUEST_STATUS';
export const updateRequestStatus = (e) => ({
  type: UPDATE_REQUEST_STATUS,
  payload: e,
});

export const SET_STATUS = 'SET_STATUS';
export const setStatus = (e) => ({
  type: SET_STATUS,
  payload: e,
});

export const SET_LAUNCHING_YEARS = 'SET_LAUNCHING_YEARS';
export const setLaunchingYears = (e) => ({
  type: SET_LAUNCHING_YEARS,
  payload: e,
});

export const SET_CONSTRUCTION_PATTERN = 'SET_CONSTRUCTION_PATTERN';
export const setConstructionPattern = (e) => ({
  type: SET_CONSTRUCTION_PATTERN,
  payload: e,
});

export const SET_BUILDINGS = 'SET_BUILDINGS';
export const setBuildings = (e) => ({
  type: SET_BUILDINGS,
  payload: e,
});

export const SET_COMPANIES = 'SET_COMPANIES';
export const setCompanies = (e) => ({
  type: SET_COMPANIES,
  payload: e,
});

export const UPDATE_REALTY_OFFERS_PRIMARY = 'UPDATE_REALTY_OFFERS_PRIMARY';
export const updateRealtyOffersPrimary = (e) => ({
  type: UPDATE_REALTY_OFFERS_PRIMARY,
  payload: e,
});

export const UPDATE_BUILDING_NAMES = 'UPDATE_BUILDING_NAMES';
export const updateBuildingNames = (e) => ({
  type: UPDATE_BUILDING_NAMES,
  payload: e,
});

export const CHANGE_SEARCH = 'CHANGE_SEARCH';
export const changeSearch = (e) => ({
  type: CHANGE_SEARCH,
  payload: e,
});

export const CLEAR_FILTERS_PRIMARY = 'CLEAR_FILTERS_PRIMARY';
export const clearFiltersPrimary = (e) => ({
  type: CLEAR_FILTERS_PRIMARY,
  payload: e,
});

export const UPDATE_REALTY_OFFERS = 'UPDATE_REALTY_OFFERS';
export const updateRealtyOffers = (e) => ({
  type: UPDATE_REALTY_OFFERS,
  payload: e,
});

export const UPDATE_BUILDING_DATA = 'UPDATE_BUILDING_DATA';
export const updateBuildingData = (payload) => ({
  type: UPDATE_BUILDING_DATA,
  payload,
});

export const UPDATE_INPUT_INTERVALS_PRIMARY = 'UPDATE_INPUT_INTERVALS_PRIMARY';
export const updateInputIntervalsPrimary = (e) => ({
  type: UPDATE_INPUT_INTERVALS_PRIMARY,
  payload: e,
});

export const SET_INFOWINDOWS_PRIMARY = 'SET_INFOWINDOWS_PRIMARY';
export const setInfowindowsPrimary = (e) => ({
  type: SET_INFOWINDOWS_PRIMARY,
  payload: e,
});

export const ADD_INFOWINDOWS_PRIMARY = 'ADD_INFOWINDOWS_PRIMARY';
export const addInfowindowsPrimary = (e) => ({
  type: ADD_INFOWINDOWS_PRIMARY,
  payload: e,
});

export const REMOVE_ALL_INFOWINDOWS_PRIMARY = 'REMOVE_ALL_INFOWINDOWS_PRIMARY';
export const removeAllInfowindowsPrimary = (e) => ({
  type: REMOVE_ALL_INFOWINDOWS_PRIMARY,
  payload: e,
});

export const CLOSE_INFOWINDOWS_PRIMARY = 'CLOSE_INFOWINDOWS_PRIMARY';
export const closeInfowindowsPrimary = (e) => ({
  type: CLOSE_INFOWINDOWS_PRIMARY,
  payload: e,
});

export const UPDATE_DISPLAY_PRIMARY_CHARTS = 'UPDATE_DISPLAY_PRIMARY_CHARTS';
export const updateDisplayPrimaryCharts = (e) => ({
  type: UPDATE_DISPLAY_PRIMARY_CHARTS,
  payload: e,
});

export const UPDATE_DISPLAY_BIG_NUMBERS_PRIMARY =
  'UPDATE_DISPLAY_BIG_NUMBERS_PRIMARY';
export const updateDisplayBigNumbersOffersPrimary = (payload) => ({
  type: UPDATE_DISPLAY_BIG_NUMBERS_PRIMARY,
  payload,
});

export const SET_FILTERED_BUILDINGS = 'SET_FILTERED_BUILDINGS';
export const setFilteredBuildings = (e) => ({
  type: SET_FILTERED_BUILDINGS,
  payload: e,
});

export const SET_FILTERED_COMPANIES = 'SET_FILTERED_COMPANIES';
export const setFilteredCompanies = (e) => ({
  type: SET_FILTERED_COMPANIES,
  payload: e,
});

export const SET_DISPLAY_GENERAL_CHARTS = 'SET_DISPLAY_GENERAL_CHARTS';
export const setDisplayGeneralCharts = (e) => ({
  type: SET_DISPLAY_GENERAL_CHARTS,
  payload: e,
});

export const UPDATE_CHARTS_DATA_PRIMARY = 'UPDATE_CHARTS_DATA_PRIMARY';
export const updateChartsDataPrimary = (e) => ({
  type: UPDATE_CHARTS_DATA_PRIMARY,
  payload: e,
});

export const SET_PDF_IMAGES = 'SET_PDF_IMAGES';
export const setPDFImages = (e) => ({
  type: SET_PDF_IMAGES,
  payload: e,
});
